export const emptyAccountInsulin = {
  id: "",
  insulin_id: "",
  form: "",
  precision: undefined,
  secondary_precision: null,
  insulin: {
    category: "",
  },
}
